import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { BUGSNAG_API_KEY, APP_VERSION } from '../env';

export function bugsnagErrorBoundary() {
  // Bugsnag has an issue so if we are in test, we have to mock this out or it breaks tests
  if (process.env.NODE_ENV === 'test')
    Object.getPrototypeOf(setTimeout()).unref = function jankyMock() {};

  const bugsnagClient = Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    appVersion: APP_VERSION,
    releaseStage: process.env.NODE_ENV,
    plugins: [new BugsnagPluginReact(React)]
  });

  return bugsnagClient.getPlugin('react').createErrorBoundary(React);
}
